import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/pro-light-svg-icons'

import Box from '../../Box'
import Text from '../../Text'

const Button = (props) => {
  const {
    boxProps,
    href,
    iconLeft,
    iconRight,
    title,
    titleTextProps,
    showAngleIcon,
    subtitle,
    subtitleTextProps,
    onClick,
  } = props

  return (
    <Box
      as="a"
      border="1px solid"
      borderColor="lineColor"
      borderRadius="5px"
      href={href}
      onClick={onClick}
      marginBottom="medium"
      paddingX="large"
      paddingY={['xlarge', 'large']}
      position="relative"
      style={{ cursor: 'pointer', textDecoration: 'none' }}
      {...boxProps}
    >
      {iconLeft && (
        <Box alignItems="center" justifyContent="center" marginRight="large" width={40}>
          {iconLeft}
        </Box>
      )}

      <Box justifyContent="center" flexDirection="column">
        <Text fontSize="small" {...titleTextProps}>{title}</Text>
        {subtitle && (
          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium" {...subtitleTextProps}>
            {subtitle}
          </Text>
        )}
      </Box>

      <Box alignItems="center" justifyContent="flex-end" marginLeft="auto" width="auto">
        <Text>{iconRight}</Text>

        {showAngleIcon && (
          <Text color="bodyFontLightColor" fontSize="xlarge" marginLeft="medium">
            <FontAwesomeIcon icon={faAngleRight} />
          </Text>
        )}
      </Box>
    </Box>
  )
}

Button.propTypes = {
  boxProps: PropTypes.object,
  href: PropTypes.string,
  iconLeft: PropTypes.node,
  iconRight: PropTypes.node,
  onClick: PropTypes.func,
  showAngleIcon: PropTypes.bool,
  subtitle: PropTypes.string,
  subtitleTextProps: PropTypes.object,
  title: PropTypes.string,
  titleTextProps: PropTypes.object,
}

export default Button
